/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscriptions_AmountInputs */

const en_admin_subscriptions_amount = /** @type {(inputs: Admin_Subscriptions_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Admin_Subscriptions_AmountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_amount = /** @type {((inputs?: Admin_Subscriptions_AmountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_AmountInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_subscriptions_amount(inputs)
});
export { admin_subscriptions_amount as "admin.subscriptions.amount" }